var _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "205.188 -294.319 30 30",
    enableBackground: "new 205.188 -294.319 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Layer_x3E_"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#49494A",
    d: "M218.102-277.729l-1.224,2.957h2.386L217.716-270l4.901-6.384h-2.031l0.571-1.11 C220.078-277.363,219.071-277.594,218.102-277.729z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#49494A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M223.15-278.206c-2.385,1.483-4.39,0.307-6.301,0.397c-1.235,0.772-3.062,0.369-3.786-0.951 c-0.119-0.203-0.956-0.547-1.139-0.578c-1.363-0.23-2.622-1.804-2.198-3.599c0.344-1.455,1.863-2.337,3.506-2.054 c0.063,0.011,0.132-0.011,0.193-0.018c0.205-0.462,0.37-0.935,0.613-1.363c1.667-2.933,5.979-3.044,7.779-0.194 c0.249,0.395,0.413,0.56,0.939,0.396c1.642-0.513,3.286,0.453,3.76,2.122c0.042,0.147,0.095,0.29,0.155,0.469 c1.3-0.348,2.417-0.114,3.251,0.961c0.706,0.909,0.788,1.929,0.293,2.944c-0.497,1.019-1.357,1.582-2.511,1.555 c-0.502-0.012-0.889,0.088-1.292,0.411C225.602-277.06,224.091-277.922,223.15-278.206z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunder);
export default __webpack_public_path__ + "static/media/thunder.5424fbef715103457118f1847a4495dc.svg";
export { ForwardRef as ReactComponent };